export default __webpack_public_path__ + "static/media/photo.5080610d.png";